//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NsProductDetailBase from "./NsProductDetailBase.vue";
import NsProductMixin from "../mixins/NsProductMixin.js";
import { events } from "@nuskin/ns-util";

/**
 * NsProductDetail
 *
 * How to use: Any variables used in the template that are not props in this
 * component come from the mixin.
 *
 * @event product-update  When a product is updated this event emits a function
 * with params: (product)
 */

export default {
  name: "NsProductDetail",
  components: {
    NsProductDetailBase
  },
  mixins: [NsProductMixin],
  props: {
    /**
     * Always show the sv value
     */
    forcesv: Boolean,
    /**
     * Hides the Exclusive Icon
     */
    hideExclusiveIcon: Boolean,
    /**
     * Hides Exclusive Text only on mobile
     */
    hideExclusiveTextOnMobile: Boolean,
    /**
     * Hides the Favorites Icon
     */
    hideFavorites: Boolean,
    /**
     * Hides the Info Section at the bottom
     */
    hideInfo: Boolean,
    /**
     * Hides the Sku number
     */
    hideSku: Boolean,
    /**
     * Force showing the ADR price
     * Warning: Don't change casing, named "showadrprice" in hello-ui
     */
    showadrprice: Boolean
  },
  data() {
    return {
      loadFirstVariant: true,
      referrer: "productPage"
    };
  },
  watch: {
    title() {
      this.sendAnalytics();
    }
  },
  methods: {
    sendAnalytics() {
      let tries = 0;
      this.analyticsInterval = setInterval(() => {
        if (window.dataLayer && window.ga && window.ga.loaded) {
          const impression = {
            event: events.shop.PRODUCT_IMPRESSION_DETAIL,
            ecommerce: {
              detail: {
                products: [
                  {
                    id: this.activeSku,
                    name: this.title
                    // TODO: uncomment below when these fields are available (contentstack is up)
                    // category: this.category,
                    // brand: this.brand,
                    // variant: this.variant
                  }
                ]
              }
            }
          };
          window.dataLayer.push(impression);
          clearInterval(this.analyticsInterval);
          this.analyticsInterval = null;
          return;
        }

        tries += 1;

        if (tries > 50) {
          clearInterval(this.analyticsInterval);
          this.analyticsInterval = null;
        }
      }, 200);
    }
  }
};
